<template>
  <div class="nnform auth">
    <tabs class="mt-3 px-2" @select="clearInputs">
      <tab name="Восстановить по телефону" :selected="true">
        <checkout-input-phone @unset="unsetError('auth.phone')" :error="errors['auth.phone']" v-model="auth.phone" label="Телефон"></checkout-input-phone>
      </tab>
      <tab name="Восстановить по E-mail">
        <checkout-input @unset="unsetError('auth.email')" :error="errors['auth.email']" v-model="auth.email" label="E-mail"></checkout-input>
      </tab>
    </tabs>

    <div class="nnform-row px-2 mt-3">
      <button type="button" class="btn-main" @click="process">Восстановить пароль</button>
    </div>
  </div>
</template>

<script>

import Tabs from "../../tabs/Tabs.vue";
import Tab from "../../tabs/Tab.vue";
import CheckoutInput from "../../checkout/form/CheckoutInput.vue";
import CheckoutInputPhone from "../../checkout/form/CheckoutInputMask.vue";
import CheckoutCheckbox from "../../checkout/form/CheckoutCheckbox.vue";
import axios from "axios";

export default {
  name: "PasswordRecoveryForm",

  components: {
    Tabs,
    Tab,
    CheckoutInput,
    CheckoutInputPhone,
    CheckoutCheckbox,
  },

  data: function () {
    return {
      errors: {},
      auth: {
        email: null,
        phone: null,
        password: null,
        remember: false,
      },
    };
  },
  methods: {
    setError(key, message) {
      this.errors[key] = message;
    },
    unsetError(key) {
      this.errors[key] = false;
    },
    validateLoginForm() {

      if (!this.auth.email) {
        this.setError('auth.email', 'Введите E-mail адрес');
      }

      if (!this.auth.phone) {
        this.setError('auth.phone', 'Введите номер телефона');
      }


      if (this.auth.email) {
        this.unsetError('auth.phone');
      }
      if (this.auth.phone) {
        this.unsetError('auth.email');
      }
    },
    hasErrorsLoginForm() {
      return this.errors['auth.phone'] && this.errors['auth.phone'] !== false
          || this.errors['auth.email'] && this.errors['auth.email'] !== false;
    },
    process() {
      this.validateLoginForm();

      if (this.hasErrorsLoginForm()) {
        return false;
      }

      axios.post('', {
        email: this.auth.email,
        phone: this.auth.phone,
      }, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'multipart/form-data',
          'X-Requested-With': 'XMLHttpRequest',
        }
      })
          .then(response => {
            this.$emit('success', response);
          })
          .catch(error => {
            this.$emit('error', error);
          });
    },
    clearInputs() {
      this.auth.email = null;
      this.auth.phone = null;
    }
  }
}
</script>

<style scoped>

</style>